import { Box, Breadcrumbs, Button, CardHeader, FormControl, IconButton, InputAdornment, Link, OutlinedInput, Skeleton, Tooltip, Typography } from '@mui/material';
import React, { useState, useEffect, useMemo, useCallback } from 'react';
import Grid from '@mui/system/Unstable_Grid';
import { ConfirmDialog, DynamicCard, HistoryTimeline, MdiIcon } from '@components';
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table';
import moment from 'moment';
import { mdiClipboard, mdiMagnify, mdiPencil, mdiPlus, mdiTrashCan } from '@mdi/js';
import { useModal } from 'mui-modal-provider';
import DialogEncomenda from './dialogs/encomenda';
import DialogAgendamento from './dialogs/agendamento';
import DialogConfirmRececao from './dialogs/confirm-rececao';
import DialogCancelamento from './dialogs/devolucao';
import DialogViatura from './dialogs/viatura';
import DialogArtigo from './dialogs/artigo';
import FaturacaoChart from './chart';
import DialogPef from './dialogs/pef';
import DialogEditCliente from './dialogs/cliente';
import DialogCusto from './dialogs/custo';
import DialogPesquisa from './dialogs/pesquisa';
import DialogPrazo from './dialogs/prazo';
import DialogFicheiro from './dialogs/anexo';
import DialogDetalhes from './dialogs/detalhes';
import DialogFotografias from './dialogs/fotografias';
import DialogInteracao from './dialogs/interacao';
import DialogCancelInteracao from './dialogs/cancel-interacao';
const random = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1)) + min;
};
const OblerProcessosDetailsView = ({ $state, UIService, OblProcessoService }) => {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState(null);
    const [tecnicos, setTecnicos] = useState([]);
    const [viaturas, setViaturas] = useState([]);
    const [interacoes, setInteracoes] = useState([]);
    const [artigos, setArtigos] = useState([]);
    const [encomendas, setEncomendas] = useState([]);
    const [custos, setCustos] = useState([]);
    const [anexos, setAnexos] = useState([]);
    const [valencias, setValencias] = useState([]);
    const [faturacao, setFaturacao] = useState([]);
    const [estados, setEstados] = useState([]);
    const [lotes, setLotes] = useState([]);
    const [motivos, setMotivos] = useState([]);
    // Relativo a faturacao
    const [total, setTotal] = useState(0);
    const [pendente, setPendente] = useState(0);
    const [faturado, setFaturado] = useState(0);
    const { showModal } = useModal();
    const isVisitaTecnica = (row) => row.tipoId == 3 || (row.tipoId == 2 && row.extra == 1);
    const getEstadoInteracao = (row) => {
        if (row?.dataSubmissao == null) {
            return 'Aguarda submissão';
        }
        if (row?.realizada == 1) {
            if (isVisitaTecnica(row)) {
                return 'Visita técnica realizada';
            }
            else {
                switch (row?.aceite) {
                    case 0:
                        return 'Orçamento não aceite';
                    case 1:
                        return 'Orçamento aceite';
                    case 2:
                        return 'Aguarda resposta do cliente';
                    case 3:
                        return 'Pendente de fecho';
                }
            }
        }
        else {
            return `Não realizada ${row.motivoId ? `(${row?.Motivo?.designacao})` : ''}`;
        }
        return '';
    };
    const getValorProcesso = () => {
        let valorProcesso = 0;
        if (data?.Lote) {
            switch (data?.Lote?.lote) {
                case 1:
                    valorProcesso = data?.Valencia?.pvpLote1;
                    break;
                case 2:
                    valorProcesso = data?.Valencia?.pvpLote2;
                    break;
                case 3:
                    valorProcesso = data?.Valencia?.pvpLote3;
                    break;
                case 4:
                    valorProcesso = data?.Valencia?.pvpLote4;
                    break;
                default:
                    break;
            }
        }
        valorProcesso = valorProcesso ?? 0;
        return valorProcesso.toLocaleString('pt-PT', { style: 'currency', currency: 'eur', maximumFractionDigits: 2 });
    };
    const generatePefData = () => {
        if (loading)
            return;
        let auxFaturado = 0;
        let auxPendente = 0;
        let valorProcesso = 0;
        if (data?.Lote) {
            switch (data?.Lote?.lote) {
                case 1:
                    valorProcesso = data?.Valencia?.pvpLote1;
                    break;
                case 2:
                    valorProcesso = data?.Valencia?.pvpLote2;
                    break;
                case 3:
                    valorProcesso = data?.Valencia?.pvpLote3;
                    break;
                case 4:
                    valorProcesso = data?.Valencia?.pvpLote4;
                    break;
                default:
                    break;
            }
        }
        let valorArtigos = 0;
        let valorCustos = 0;
        // Processo
        let linhaFaturaProcesso = faturacao.find(r => r.oblArtigoProcessoId == null && r.oblCustoProcessoId == null);
        if (linhaFaturaProcesso) {
            if (linhaFaturaProcesso.faturado) {
                auxFaturado += valorProcesso;
            }
            else {
                auxPendente += valorProcesso;
            }
        }
        // Artigos
        artigos.forEach(artigo => {
            let valor = artigo.pvp * artigo.quantidadeFaturada;
            valorArtigos += valor;
            let linhaFatura = faturacao.find(r => r.oblArtigoProcessoId == artigo.id);
            if (linhaFatura) {
                if (linhaFatura.faturado) {
                    auxFaturado += valor;
                }
                else {
                    auxPendente += valor;
                }
            }
        });
        // Custos
        custos
            .filter(r => r.temValor)
            .forEach(custo => {
            let valor = custo.valor * custo.quantidade;
            valorCustos += valor;
            let linhaFatura = faturacao.find(r => r.oblCustoProcessoId == custo.id);
            if (linhaFatura) {
                if (linhaFatura.faturado) {
                    auxFaturado += valor;
                }
                else {
                    auxPendente += valor;
                }
            }
        });
        setTotal(valorArtigos + valorCustos + valorProcesso);
        setPendente(auxPendente);
        setFaturado(auxFaturado);
    };
    const isOrcamentoValid = (interacaoId) => {
        const interacao = interacoes.find(i => i.id === interacaoId);
        if (!interacao)
            return false;
        return interacao.realizada === 1 && interacao.aceite === 1;
    };
    const isOrcamentoOpen = (interacaoId) => {
        const interacao = interacoes.find(i => i.id === interacaoId);
        if (!interacao)
            return false;
        return interacao.realizada === 1 && interacao.validado === 0;
    };
    const getEstadoOrcamento = (row) => {
        if (row?.cancelado === 1) {
            return `Cancelado ${row?.justificacao ? `(${row?.justificacao})` : ''}`;
        }
        else {
            if (row?.rececionado === 1) {
                return 'Rececionado';
            }
            if (row?.encomendado === 1) {
                return 'Encomendado';
            }
            if (row?.encomendado === 0) {
                return 'Aguarda encomenda';
            }
        }
    };
    const tableInteracoes = useMaterialReactTable({
        enableColumnActions: false,
        enableColumnFilters: false,
        enablePagination: false,
        enableSorting: false,
        enableBottomToolbar: false,
        initialState: {
            density: 'compact'
        },
        localization: {
            actions: '',
            noRecordsToDisplay: 'Não existem interações para este processo'
        },
        renderTopToolbar: () => (<CardHeader title='Interações' action={<Tooltip title='Adicionar interação'>
            <IconButton onClick={async () => {
                    showModal(DialogInteracao, {
                        tecnicos: tecnicos,
                        maxWidth: 'md',
                        fullWidth: true,
                        onClose: async (_) => {
                            if (_) {
                                await OblProcessoService.createInteracao($state.params.id, _.tipoId, data.estadoId, true, moment(_.data).format(), _.tecnicoId);
                                fetchData();
                                UIService.addToast('Interação criada com sucesso');
                            }
                        }
                    });
                }}>
              <MdiIcon path={mdiPlus}/>
            </IconButton>
          </Tooltip>}/>),
        enableRowActions: true,
        positionActionsColumn: 'last',
        renderRowActions: ({ row, table }) => row.original.dataSubmissao ? (<Box sx={{ display: 'flex' }}>
          {isVisitaTecnica(row.original) && row.original.realizada == 1 && !row.original.validado && (<Button size='small' color='primary' onClick={async () => {
                    const estadoId = data.estadoId;
                    showModal(ConfirmDialog, {
                        fullWidth: true,
                        maxWidth: 'lg',
                        message: 'Tem a certeza que deseja fechar a interação?',
                        onClose: async (_) => {
                            if (_) {
                                await OblProcessoService.patchInteracao(row.original.id, {
                                    validado: 1
                                });
                                fetchData();
                                UIService.addToast('Interação fechada com sucesso');
                            }
                        }
                    });
                }}>
              Fechar interação
            </Button>)}
          {(!row.original.realizada || (isVisitaTecnica(row.original) && row.original.realizada == 1 && !row.original.validado)) && (<Button size='small' color='primary' onClick={async () => {
                    const estadoId = data.estadoId;
                    showModal(DialogAgendamento, {
                        fullWidth: true,
                        maxWidth: 'lg',
                        tecnicos: tecnicos,
                        onClose: async ({ data, tecnicoId }) => {
                            if (data) {
                                const o = await OblProcessoService.createInteracao($state.params.id, row.original.tipoId, estadoId, true, data, tecnicoId);
                                await OblProcessoService.patchInteracao(row.original.id, {
                                    validado: 1,
                                    filhoId: o.id
                                });
                                fetchData();
                                UIService.addToast('Reagendado com sucesso');
                            }
                        }
                    });
                }}>
              Reagendar
            </Button>)}
          {!isVisitaTecnica(row.original) && row.original.realizada == 1 && row.original.aceite === 1 && row.original.validado && !row.original.filhoId && (<Button size='small' color='primary' onClick={async () => {
                    const estadoId = data.estadoId;
                    const hasPendingEncomendasOrRececoes = row.original.Orcamentacao.filter(r => r.cancelado === 0).filter(r => r.encomendado === 0 || r.rececionado === 0);
                    if (hasPendingEncomendasOrRececoes.length > 0) {
                        await UIService.showAlert('Existem linhas por encomendar / rececionar. Não é possível agendar visita técnica.');
                    }
                    else {
                        showModal(DialogAgendamento, {
                            fullWidth: true,
                            maxWidth: 'lg',
                            tecnicos: tecnicos,
                            onClose: async ({ data, tecnicoId }) => {
                                if (data && tecnicoId) {
                                    setLoading(true);
                                    const o = await OblProcessoService.createInteracao($state.params.id, 3, estadoId, true, data, tecnicoId);
                                    await OblProcessoService.patchInteracao(row.original.id, {
                                        validado: 1,
                                        filhoId: o.id
                                    });
                                    fetchData();
                                    UIService.addToast('Visita técnica agendada com sucesso');
                                }
                            }
                        });
                    }
                }}>
              Agendar visita técnica
            </Button>)}
          {!isVisitaTecnica(row.original) && row.original.realizada == 1 && !row.original.validado && (<Button size='small' color='primary' onClick={async () => {
                    const d = await UIService.showConfirm('Tem a certeza que deseja fechar a interação?');
                    if (d) {
                        await OblProcessoService.fechaOrcamento(row.original.id, $state.params.id, data.estadoId);
                        fetchData();
                    }
                }}>
              Fechar
            </Button>)}
          {!isVisitaTecnica(row.original) && row.original.realizada == 1 && row.original.aceite === 2 && row.original.validado && (<Box sx={{ display: 'flex' }}>
              <Button size='small' color='primary' onClick={async () => {
                    const d = await UIService.showConfirm('Tem a certeza que deseja marcar que o orçamento foi aceite pelo cliente?');
                    if (d) {
                        await OblProcessoService.aceitaOrcamento(row.original.id, $state.params.id, data.estadoId);
                        fetchData();
                        UIService.addToast('Orçamento marcado como aceite');
                    }
                }}>
                Aceite
              </Button>
              <Button size='small' color='primary' onClick={async () => {
                    const d = await UIService.showConfirm('Tem a certeza que deseja marcar que o orçamento foi rejeitado pelo cliente?');
                    if (d) {
                        await OblProcessoService.rejeitaOrcamento(row.original.id, $state.params.id, data.estadoId);
                        fetchData();
                        UIService.addToast('Orçamento marcado como não aceite');
                    }
                }}>
                Não Aceite
              </Button>
            </Box>)}
        </Box>) : (<Box>
          <Button size='small' color='primary' onClick={async () => {
                let aux1 = moment(row.original?.Agendamento?.data, 'YYYY-MM-DD');
                let date = moment(`${aux1.format('YYYY-MM-DD')} ${row.original.Agendamento?.hora}`, 'YYYY-MM-DD HH:mm:ss');
                showModal(DialogAgendamento, {
                    initial: {
                        tecnicoId: row.original?.Agendamento?.tecnicoId,
                        data: date
                    },
                    fullWidth: true,
                    maxWidth: 'lg',
                    tecnicos: tecnicos,
                    onClose: async ({ data, tecnicoId }) => {
                        if (data) {
                            await OblProcessoService.patchAgendamento(row.original.Agendamento.id, data, tecnicoId);
                            fetchData();
                            UIService.addToast('Reageandamento efetuado com sucesso');
                        }
                    }
                });
            }}>
            Reagendar
          </Button>
          <Button size='small' color='primary' onClick={async () => {
                showModal(DialogCancelInteracao, {
                    initial: {},
                    motivos: motivos,
                    fullWidth: true,
                    maxWidth: 'lg',
                    onClose: async (motivoId) => {
                        if (motivoId) {
                            await OblProcessoService.patchInteracao(row.original.id, {
                                motivoId: motivoId,
                                realizada: 0,
                                dataSubmissao: moment().format(),
                                validado: 1
                            });
                            fetchData();
                            UIService.addToast('Reageandamento efetuado com sucesso');
                        }
                    }
                });
            }}>
            Cancelar
          </Button>
        </Box>),
        columns: [
            {
                accessorKey: 'id',
                header: '#',
                size: 50
            },
            {
                accessorKey: 'InteracaoTipo.designacao',
                header: 'Tipo de Interação',
                size: 160,
                Cell: ({ cell, row }) => (<span>
            {cell.getValue()} {row.original.extra ? `(Resolvido no local)` : ''}
          </span>)
            },
            {
                accessorFn: (row) => getEstadoInteracao(row),
                header: 'Estado'
            },
            {
                accessorFn: () => 'oooo',
                header: 'Fotografias',
                Cell: ({ row }) => {
                    return row ? (<Link onClick={() => {
                            showModal(DialogFotografias, {
                                images: row.original.Fotografias.map(r => r.imagem),
                                maxWidth: 'lg',
                                fullWidth: true,
                                onClose: () => { }
                            });
                        }}>
              Visualizar
            </Link>) : ('-');
                }
            },
            {
                accessorKey: 'Agendamento.data',
                header: 'Agendamento',
                Cell: ({ cell, row }) => (<span>
            {row.original?.Agendamento ? moment(cell.getValue()).format('DD-MM-YYYY') : '-'} {row.original?.Agendamento ? row.original?.Agendamento?.hora.substring(0, 5) : ''}
          </span>)
            },
            {
                accessorKey: 'Agendamento.Funcionario.name',
                header: 'Técnico'
            },
            {
                accessorKey: 'Agendamento.AgendadoPor.name',
                header: 'Agendado Por'
            },
            {
                accessorKey: 'Agendamento.agendadoa',
                header: 'Agendado a',
                Cell: ({ cell }) => <span>{cell.getValue() ? moment(cell.getValue()).format('DD-MM-YYYY [às] HH:mm') : '-'}</span>
            },
            {
                accessorKey: 'observacoes',
                header: 'Observações'
            }
        ],
        data: interacoes
    });
    const tableMateriais = useMaterialReactTable({
        enableColumnActions: false,
        enableColumnFilters: false,
        enablePagination: false,
        enableSorting: false,
        muiBottomToolbarProps: {
            justifyContent: 'flex-end'
        },
        initialState: {
            density: 'compact'
        },
        localization: {
            noRecordsToDisplay: 'Não existem artigos aplicados a este processo'
        },
        renderTopToolbar: ({ table }) => (<CardHeader title='Artigos aplicados' action={canoDoVisitaTecnicas() && (<Tooltip title='Adicionar artigo'>
              <IconButton onClick={async () => {
                    let aux = viaturas.filter(r => r.Stock && r.Stock.length > 0);
                    showModal(DialogViatura, {
                        viaturas: aux,
                        maxWidth: 'md',
                        fullWidth: true,
                        onClose: async ({ viaturaId }) => {
                            if (viaturaId) {
                                let stock = aux.find(r => r.id == viaturaId).Stock;
                                let o = artigos.filter(r => r.interacaoId == interacoes[0].id).map(r => r.produtoId);
                                stock = stock.filter(r => !o.includes(r.produtoId));
                                showModal(DialogArtigo, {
                                    stock: stock,
                                    maxWidth: 'lg',
                                    fullWidth: true,
                                    onClose: async (artigo) => {
                                        await OblProcessoService.createLinhaArtigo(interacoes[0].id, viaturaId, artigo.produtoId, artigo.quantidadeEfetiva, artigo.quantidadeFaturada, artigo.pvp);
                                        fetchData();
                                        UIService.addToast('Linha de artigo adicionada com sucesso');
                                    }
                                });
                            }
                        }
                    });
                }}>
                <MdiIcon path={mdiPlus}/>
              </IconButton>
            </Tooltip>)}></CardHeader>),
        renderBottomToolbarCustomActions: ({ table }) => (<Box sx={{ mr: 1 }}>
        {artigos.length > 0 && (<FormControl fullWidth sx={{ m: 1 }}>
            <OutlinedInput size='small' disabled value={`Total: ${artigos
                    .reduce((acc, row) => {
                    if (row.quantidadeFaturada > 0) {
                        return acc + row.quantidadeFaturada * row.pvp;
                    }
                    return acc;
                }, 0)
                    .toLocaleString('pt-PT', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 })}`} endAdornment={<InputAdornment position='end'>€</InputAdornment>}/>
          </FormControl>)}
      </Box>),
        columns: [
            {
                accessorKey: 'id',
                header: '#',
                size: 50
            },
            {
                accessorKey: 'Produto.primaveraId',
                header: 'Cód. Artigo',
                size: 80
            },
            {
                accessorKey: 'Produto.designacao',
                header: 'Designação'
            },
            {
                accessorKey: 'interacaoId',
                header: '# Interação',
                size: 80
            },
            /*
            {
              accessorKey: 'faturado',
              header: 'Pedida Fatura?',
              size: 80,
              Cell: ({ cell }) => <span>{cell.getValue() == 1 ? 'Sim' : 'Não'}</span>
            },
            */
            {
                accessorKey: 'quantidadeEfetiva',
                header: 'Qtd. Efetiva',
                size: 80,
                Cell: ({ cell }) => <span>{cell.getValue().toLocaleString('pt-PT', { style: 'decimal', maximumFractionDigits: 2 })}</span>,
                muiTableHeadCellProps: {
                    align: 'right'
                },
                muiTableBodyCellProps: {
                    align: 'right'
                }
            },
            {
                accessorKey: 'quantidadeFaturada',
                header: 'Qtd. Faturada',
                size: 80,
                Cell: ({ cell }) => <span>{cell.getValue().toLocaleString('pt-PT', { style: 'decimal', maximumFractionDigits: 2 })}</span>,
                muiTableHeadCellProps: {
                    align: 'right'
                },
                muiTableBodyCellProps: {
                    align: 'right'
                }
            },
            {
                accessorKey: 'pvp',
                header: 'Preço Unitário',
                size: 100,
                Cell: ({ cell }) => <span>{cell.getValue().toLocaleString('pt-PT', { style: 'currency', currency: 'eur', maximumFractionDigits: 2 })}</span>,
                muiTableHeadCellProps: {
                    align: 'right'
                },
                muiTableBodyCellProps: {
                    align: 'right'
                }
            },
            {
                accessorFn: row => row.quantidadeFaturada * row.pvp,
                Cell: ({ cell }) => <span>{cell.getValue().toLocaleString('pt-PT', { style: 'currency', currency: 'eur', maximumFractionDigits: 2 })}</span>,
                size: 100,
                header: 'Total linha',
                muiTableHeadCellProps: {
                    align: 'right'
                },
                muiTableBodyCellProps: {
                    align: 'right'
                }
            }
        ],
        data: artigos
    });
    const tableEncomendas = useMaterialReactTable({
        enableColumnActions: false,
        enableColumnFilters: false,
        enablePagination: false,
        enableSorting: false,
        muiBottomToolbarProps: {
            justifyContent: 'flex-end'
        },
        initialState: {
            density: 'compact'
        },
        localization: {
            actions: '',
            noRecordsToDisplay: 'Não existem encomendas para este processo'
        },
        enableRowActions: true,
        positionActionsColumn: 'last',
        renderRowActions: ({ row, table }) => !row.original.cancelado ? (<Box sx={{ display: 'flex' }}>
          {isOrcamentoOpen(row.original.interacaoId) ? (<Tooltip title='Editar linha'>
              <IconButton size='small' onClick={async () => {
                    showModal(DialogEncomenda, {
                        initial: row.original,
                        fullWidth: true,
                        maxWidth: 'lg',
                        onClose: async (data) => {
                            if (data) {
                                await OblProcessoService.editLinhaOrcamento(row.original.id, data);
                                fetchData();
                                UIService.addToast('Linha editada com sucesso');
                            }
                        }
                    });
                }}>
                <MdiIcon path={mdiPencil}/>
              </IconButton>
            </Tooltip>) : (<></>)}
          {isOrcamentoOpen(row.original.interacaoId) ? (<Tooltip title='Remover linha'>
              <IconButton size='small' onClick={async () => {
                    const d = UIService.showConfirm('Tem a certeza que deseja remover a linha?').then(async (d) => {
                        await OblProcessoService.editLinhaOrcamento(row.original.id, {
                            active: 0
                        });
                        fetchData();
                        UIService.addToast('Linha removida com sucesso');
                    });
                }}>
                <MdiIcon path={mdiTrashCan}/>
              </IconButton>
            </Tooltip>) : (<></>)}
          {isOrcamentoValid(row.original.interacaoId) && !row.original.encomendado ? (<Button size='small' color='primary' onClick={async () => {
                    showModal(DialogEncomenda, {
                        initial: row.original,
                        fullWidth: true,
                        maxWidth: 'lg',
                        onClose: async (data) => {
                            if (data) {
                                await OblProcessoService.encomendaLinhaOrcamento(row.original.id, data);
                                fetchData();
                                UIService.addToast('Linha marcada como encomendada');
                            }
                        }
                    });
                }}>
              Encomendar
            </Button>) : (<></>)}
          {isOrcamentoValid(row.original.interacaoId) && row.original.encomendado && !row.original.rececionado ? (<Button size='small' color='primary' onClick={async () => {
                    showModal(DialogPrazo, {
                        fullWidth: true,
                        maxWidth: 'lg',
                        initial: row.original.prazo,
                        onClose: async ({ data }) => {
                            if (data) {
                                await OblProcessoService.editLinhaOrcamento(row.original.id, data);
                                fetchData();
                                UIService.addToast('Linha editada com sucesso');
                            }
                        }
                    });
                }}>
              Alterar prazo
            </Button>) : (<></>)}
          {isOrcamentoValid(row.original.interacaoId) && row.original.encomendado && !row.original.rececionado ? (<Button size='small' color='primary' onClick={async () => {
                    showModal(DialogConfirmRececao, {
                        fullWidth: true,
                        maxWidth: 'lg',
                        onClose: async ({ primavera }) => {
                            if (primavera) {
                                await OblProcessoService.rececionaLinhaOrcamento(row.original.id, primavera);
                                fetchData();
                                UIService.addToast('Linha marcada como rececionada');
                            }
                        }
                    });
                }}>
              Confirmar receção
            </Button>) : (<></>)}
          {row.original.encomendado && !row.original.rececionado ? (<Button size='small' color='primary' onClick={async () => {
                    showModal(DialogCancelamento, {
                        fullWidth: true,
                        isDevolucao: false,
                        maxWidth: 'lg',
                        onClose: async ({ justificacao }) => {
                            if (justificacao) {
                                await OblProcessoService.cancelaLinhaOrcamento(row.original.id, justificacao);
                                fetchData();
                                UIService.addToast('Linha de orçamento marcada como cancelada');
                            }
                        }
                    });
                }}>
              Cancelar encomenda
            </Button>) : (<></>)}
          {row.original.encomendado && row.original.rececionado ? (<Button size='small' color='primary' onClick={async () => {
                    showModal(DialogCancelamento, {
                        fullWidth: true,
                        isDevolucao: true,
                        maxWidth: 'lg',
                        onClose: async ({ justificacao }) => {
                            if (justificacao) {
                                await OblProcessoService.cancelaLinhaOrcamento(row.original.id, justificacao);
                                fetchData();
                                UIService.addToast('Linha de orçamento marcada como devolvida');
                            }
                        }
                    });
                }}>
              Devolução de produto
            </Button>) : (<></>)}
          {!row.original.cancelado && !row.original.rececionado ? (<Tooltip title='Editar'>
              <IconButton size='small' onClick={async () => {
                    showModal(DialogEncomenda, {
                        initial: row.original,
                        fullWidth: true,
                        maxWidth: 'lg',
                        onClose: async (data) => {
                            if (data) {
                                await OblProcessoService.editLinhaOrcamento(row.original.id, data);
                                fetchData();
                                UIService.addToast('Linha editada com sucesso');
                            }
                        }
                    });
                }}>
                <MdiIcon path={mdiPencil}/>
              </IconButton>
            </Tooltip>) : (<></>)}
        </Box>) : (<></>),
        renderTopToolbar: ({ table }) => (<CardHeader title='Encomendas' action={<Box>
            <Tooltip title='Procurar'>
              <IconButton onClick={async () => {
                    showModal(DialogPesquisa, {
                        maxWidth: 'lg',
                        fullWidth: true,
                        service: OblProcessoService,
                        onClose: () => { }
                    });
                }}>
                <MdiIcon path={mdiMagnify}/>
              </IconButton>
            </Tooltip>
            {canDoEncomendas() ? (<Tooltip title='Adicionar encomenda'>
                <IconButton onClick={async () => {
                        if (true) {
                            showModal(DialogEncomenda, {
                                maxWidth: 'lg',
                                fullWidth: true,
                                initial: null,
                                onClose: async (linha) => {
                                    if (linha) {
                                        await OblProcessoService.createLinhaOrcamento(interacoes[0].id, linha);
                                        fetchData();
                                        UIService.addToast('Linha de orçamento criada com sucesso');
                                    }
                                }
                            });
                        }
                    }}>
                  <MdiIcon path={mdiPlus}/>
                </IconButton>
              </Tooltip>) : (<></>)}
          </Box>}></CardHeader>),
        renderBottomToolbarCustomActions: ({ table }) => encomendas.length > 0 ? (<Box sx={{ display: 'flex' }}>
          <Box sx={{ mr: 1 }}>
            <FormControl fullWidth sx={{ m: 1 }}>
              <OutlinedInput size='small' disabled value={`Encomendado: ${encomendas.filter(r => r.cancelado === 0 && r.encomendado).length}/${encomendas.filter(r => r.cancelado === 0).length}`}/>
            </FormControl>
          </Box>
          <Box sx={{ mr: 1 }}>
            <FormControl fullWidth sx={{ m: 1 }}>
              <OutlinedInput size='small' disabled value={`Rececionado: ${encomendas.filter(r => r.cancelado === 0 && r.rececionado).length}/${encomendas.filter(r => r.cancelado === 0).length}`}/>
            </FormControl>
          </Box>
          <Box sx={{ mr: 1 }}>
            <FormControl fullWidth sx={{ m: 1 }}>
              <OutlinedInput size='small' disabled value={`Total: ${encomendas
                .filter(r => r.cancelado === 0)
                .reduce((acc, row) => acc + row.preco * row.quantidade, 0)
                .toLocaleString('pt-PT', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 })}`} endAdornment={<InputAdornment position='end'>€</InputAdornment>}/>
            </FormControl>
          </Box>
        </Box>) : (<></>),
        columns: [
            {
                accessorKey: 'id',
                header: '#',
                size: 50
            },
            {
                accessorKey: 'designacao',
                header: 'Designação'
            },
            {
                accessorKey: 'codigo',
                header: 'Código',
                size: 80,
                Cell: ({ cell }) => <span>{cell.getValue() ? cell.getValue() : '-'}</span>
            },
            {
                accessorKey: 'fornecedor',
                header: 'Fornecedor',
                size: 120
            },
            {
                accessorKey: 'interacaoId',
                header: '# Interação',
                size: 80
            },
            {
                accessorKey: 'quantidade',
                header: 'Quantidade',
                size: 80,
                Cell: ({ cell }) => <span>{cell.getValue().toLocaleString('pt-PT', { style: 'decimal', maximumFractionDigits: 2 })}</span>,
                muiTableHeadCellProps: {
                    align: 'right'
                },
                muiTableBodyCellProps: {
                    align: 'right'
                }
            },
            {
                accessorKey: 'preco',
                header: 'Preço Unitário',
                size: 100,
                Cell: ({ cell }) => <span>{cell.getValue() ? cell.getValue().toLocaleString('pt-PT', { style: 'currency', currency: 'eur', maximumFractionDigits: 2 }) : '-'}</span>,
                muiTableHeadCellProps: {
                    align: 'right'
                },
                muiTableBodyCellProps: {
                    align: 'right'
                }
            },
            {
                accessorFn: row => row.quantidade * row.preco,
                size: 100,
                Cell: ({ cell }) => <span>{cell.getValue().toLocaleString('pt-PT', { style: 'currency', currency: 'eur', maximumFractionDigits: 2 })}</span>,
                header: 'Total linha',
                muiTableHeadCellProps: {
                    align: 'right'
                },
                muiTableBodyCellProps: {
                    align: 'right'
                }
            },
            {
                accessorKey: 'fotografia',
                header: 'Fotografia',
                Cell: ({ cell }) => cell.getValue() ? (<Link href={'/api/Upload/obler-photos/download/' + cell.getValue()} rel='noopener' target='_blank'>
              Visualizar
            </Link>) : ('-')
            },
            {
                accessorKey: 'Requisitante.name',
                header: 'Requisitado por'
            },
            {
                accessorKey: 'dataRequisicao',
                header: 'Data Requisição',
                Cell: ({ cell }) => <span>{cell.getValue() ? moment(cell.getValue()).format('DD-MM-YYYY [às] HH:mm') : '-'}</span>
            },
            {
                accessorKey: 'compra',
                header: 'Cód. Encomenda',
                size: 80,
                Cell: ({ cell }) => <span>{cell.getValue() ? cell.getValue() : '-'}</span>
            },
            {
                accessorKey: 'EncomendadoPor.name',
                header: 'Encomendado por'
            },
            {
                accessorKey: 'prazo',
                header: 'Prazo (dias)'
            },
            {
                accessorKey: 'dataEncomenda',
                header: 'Data Encomenda',
                Cell: ({ cell }) => <span>{cell.getValue() ? moment(cell.getValue()).format('DD-MM-YYYY [às] HH:mm') : '-'}</span>
            },
            {
                accessorKey: 'RececionadoPor.name',
                header: 'Receção por'
            },
            {
                accessorKey: 'dataRececao',
                header: 'Data Receção',
                Cell: ({ cell }) => <span>{cell.getValue() ? moment(cell.getValue()).format('DD-MM-YYYY [às] HH:mm') : '-'}</span>
            },
            {
                accessorFn: (row) => getEstadoOrcamento(row),
                header: 'Estado'
            }
        ],
        data: encomendas
    });
    const tableCustos = useMaterialReactTable({
        enableColumnActions: false,
        enableColumnFilters: false,
        enablePagination: false,
        enableSorting: false,
        muiBottomToolbarProps: {
            justifyContent: 'flex-end'
        },
        initialState: {
            density: 'compact'
        },
        localization: {
            noRecordsToDisplay: 'Não existem custos para este processo'
        },
        renderTopToolbar: ({ table }) => (<CardHeader title='Custos' action={canoDoVisitaTecnicas() && (<Tooltip title='Adicionar custo'>
              <IconButton onClick={async () => {
                    showModal(DialogCusto, {
                        fullWidth: true,
                        maxWidth: 'lg',
                        initial: {},
                        onClose: async (data) => {
                            if (data) {
                                if (data.tipo == 2) {
                                    data.quantidade = 1;
                                }
                                await OblProcessoService.createLinhaCusto(interacoes[0].id, data);
                                fetchData();
                                UIService.addToast('Linha de custo criada com sucesso');
                            }
                        }
                    });
                }}>
                <MdiIcon path={mdiPlus}/>
              </IconButton>
            </Tooltip>)}></CardHeader>),
        renderBottomToolbarCustomActions: ({ table }) => (<Box sx={{ mr: 1 }}>
        <FormControl fullWidth sx={{ m: 1 }}>
          <OutlinedInput size='small' disabled value={`Total: ${custos
                .reduce((acc, row) => {
                if (row.temValor) {
                    return acc + row.quantidade * row.valor;
                }
                return acc;
            }, 0)
                .toLocaleString('pt-PT', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 })}`} endAdornment={<InputAdornment position='end'>€</InputAdornment>}/>
        </FormControl>
      </Box>),
        columns: [
            {
                accessorKey: 'id',
                header: '#',
                size: 50
            },
            {
                accessorKey: 'tipo',
                header: 'Tipo. Custo',
                size: 80,
                Cell: ({ cell }) => <span>{cell.getValue() == 1 ? 'Produto' : 'Serviço'}</span>
            },
            {
                accessorKey: 'designacao',
                header: 'Designação'
            },
            {
                accessorKey: 'interacaoId',
                header: '# Interação',
                size: 80
            },
            /*
            {
              accessorKey: 'faturado',
              header: 'Pedida Fatura?',
              size: 80,
              Cell: ({ cell }) => <span>{cell.getValue() == 1 ? 'Sim' : 'Não'}</span>
            },
            */
            {
                accessorKey: 'quantidade',
                header: 'Quantidade',
                Cell: ({ cell }) => <span>{cell.getValue().toLocaleString('pt-PT', { style: 'decimal', maximumFractionDigits: 2 })}</span>,
                muiTableHeadCellProps: {
                    align: 'right'
                },
                muiTableBodyCellProps: {
                    align: 'right'
                }
            },
            {
                accessorFn: row => (row.temValor ? row.valor : '-'),
                header: 'Preço Unitário',
                Cell: ({ cell, row }) => <span>{row.original.temValor ? (cell.getValue() ? cell.getValue().toLocaleString('pt-PT', { style: 'currency', currency: 'eur', maximumFractionDigits: 2 }) : '-') : '-'}</span>,
                muiTableHeadCellProps: {
                    align: 'right'
                },
                muiTableBodyCellProps: {
                    align: 'right'
                }
            },
            {
                accessorFn: row => row.quantidade * (row.temValor ? row.valor : 0),
                Cell: ({ cell }) => <span>{cell.getValue().toLocaleString('pt-PT', { style: 'currency', currency: 'eur', maximumFractionDigits: 2 })}</span>,
                header: 'Total linha',
                muiTableHeadCellProps: {
                    align: 'right'
                },
                muiTableBodyCellProps: {
                    align: 'right'
                }
            }
        ],
        data: custos,
        enableRowActions: true,
        positionActionsColumn: 'last',
        renderRowActions: ({ row, table }) => (<Box>
        {!row.original.faturado ? (<Button size='small' onClick={async () => {
                    showModal(DialogPef, {
                        fullWidth: true,
                        maxWidth: 'lg',
                        onClose: async (_) => {
                            if (_) {
                                await OblProcessoService.faturaCusto(row.original.id, _.observacoes);
                                fetchData();
                                UIService.addToast('Pedido de emissão de fatura efetuado');
                            }
                        }
                    });
                }}>
            Pedido de emissão de fatura
          </Button>) : (<></>)}
      </Box>)
    });
    const tableAnexos = useMaterialReactTable({
        enableColumnActions: false,
        enableColumnFilters: false,
        enablePagination: false,
        enableSorting: false,
        muiBottomToolbarProps: {
            justifyContent: 'flex-end'
        },
        initialState: {
            density: 'compact'
        },
        localization: {
            noRecordsToDisplay: 'Não existem anexos para este processo'
        },
        renderTopToolbar: ({ table }) => (<CardHeader title='Anexos' action={<Tooltip title='Adicionar anexo'>
            <IconButton onClick={async () => {
                    showModal(DialogFicheiro, {
                        folder: 'obler',
                        allowed: ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
                        title: 'Adicionar ficheiro',
                        service: OblProcessoService,
                        onClose: async (_) => {
                            if (_) {
                                await OblProcessoService.createFicheiro($state.params.id, interacoes[0].id, _.file, _.designacao);
                                fetchData();
                                UIService.addToast('Ficheiro carregado com sucesso');
                            }
                        }
                    });
                }}>
              <MdiIcon path={mdiPlus}/>
            </IconButton>
          </Tooltip>}/>),
        columns: [
            {
                accessorKey: 'id',
                header: '#',
                size: 50
            },
            {
                accessorKey: 'interacaoId',
                header: '# Interação',
                size: 80
            },
            {
                accessorKey: 'tipodocumentoId',
                header: 'Tipo de Documento',
                Cell: ({ row }) => (row.original.tipodocumentoId == 1 ? row.original.extra : row.original.tipodocumentoId == 2 ? 'Orçamento' : 'Relatório')
            },
            {
                accessorKey: 'nome',
                header: 'Documento',
                Cell: ({ row }) => (<Link href={`/api/Upload/obler/download/${row.original.nome}`} target={'_blank'}>
            {row.original.nome}
          </Link>)
            }
        ],
        data: anexos
    });
    const tablePef = useMaterialReactTable({
        enableColumnActions: false,
        enableColumnFilters: false,
        enablePagination: false,
        enableSorting: false,
        muiBottomToolbarProps: {
            justifyContent: 'flex-end'
        },
        initialState: {
            density: 'compact'
        },
        localization: {
            noRecordsToDisplay: 'Não existem pedidos de emissão de fatura para este processo'
        },
        renderTopToolbar: ({ table }) => (<CardHeader title='Pedidos de emissão de fatura' action={canoDoVisitaTecnicas() && (<Tooltip title='Adicionar custo'>
              <IconButton onClick={async () => { }}>
                <MdiIcon path={mdiPlus}/>
              </IconButton>
            </Tooltip>)}></CardHeader>),
        columns: [
            {
                accessorKey: 'dataPedidoFaturacao',
                header: 'Data do Pedido',
                size: 80,
                Cell: ({ cell }) => <span>{cell.getValue() ? moment(cell.getValue()).format('DD/MM/YYYY HH:mm') : '-'}</span>
            },
            {
                accessorKey: 'descricao',
                header: 'Descrição'
            },
            {
                accessorKey: 'quantidade',
                header: 'Quantidade',
                size: 80,
                muiTableHeadCellProps: {
                    align: 'right'
                },
                muiTableBodyCellProps: {
                    align: 'right'
                }
            },
            {
                accessorKey: 'precoUnitario',
                header: 'Custo Unitário (€)',
                muiTableHeadCellProps: {
                    align: 'right'
                },
                muiTableBodyCellProps: {
                    align: 'right'
                },
                size: 80
            },
            {
                accessorKey: 'funcionario.name',
                header: 'Pedido por',
                size: 120,
                Cell: ({ cell }) => <span>{cell.getValue() ? cell.getValue() : '-'}</span>
            },
            {
                accessorKey: 'faturado',
                header: 'Já faturado?',
                size: 80,
                Cell: ({ cell }) => <span>{cell.getValue() == 1 ? 'Sim' : 'Não'}</span>
            },
            {
                accessorKey: 'numeroFatura',
                header: 'Nº fatura',
                size: 80,
                Cell: ({ cell }) => <span>{cell.getValue() ? cell.getValue() : '-'}</span>
            },
            {
                accessorKey: 'faturadopor.name',
                header: 'Faturado por',
                size: 120,
                Cell: ({ cell }) => <span>{cell.getValue() ? cell.getValue() : '-'}</span>
            },
            {
                accessorKey: 'dataFaturacao',
                header: 'Data de Faturação',
                size: 80,
                Cell: ({ cell }) => <span>{cell.getValue() ? moment(cell.getValue()).format('DD/MM/YYYY HH:mm') : '-'}</span>
            }
        ],
        data: faturacao
    });
    const canDoEncomendas = () => {
        if (interacoes.length > 0 && ![10, 11].includes(data.estadoId)) {
            return true;
        }
        return false;
    };
    const canoDoVisitaTecnicas = () => {
        if (interacoes.length > 0 && isVisitaTecnica(interacoes[0]) && [9].includes(data.estadoId) && !interacoes[0].validado) {
            return true;
        }
        return false;
    };
    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await OblProcessoService.details($state.params.id);
            setData(response);
            let auxI = response.Interacaos;
            auxI.sort((a, b) => b.id - a.id);
            setInteracoes(auxI);
            setArtigos(response.Interacaos.map(r => r?.InteracaoProdutos).flat());
            setEncomendas(response.Interacaos.map(r => r?.Orcamentacao).flat());
            setCustos(response.Interacaos.map(r => r?.Extras).flat());
            setFaturacao(response.Faturacao);
            setAnexos(response.Anexos);
            const rTecnicos = await OblProcessoService.findTecnicos();
            setTecnicos(rTecnicos);
            const rViaturas = await OblProcessoService.getViaturas();
            setViaturas(rViaturas);
            const rEstados = await OblProcessoService.getEstados();
            setEstados(rEstados);
            const rValencias = await OblProcessoService.getValencias();
            setValencias(rValencias);
            const rLotes = await OblProcessoService.getLotes();
            setLotes(rLotes);
            const rMotivos = await OblProcessoService.getMotivos();
            setMotivos(rMotivos);
        }
        catch (error) {
            console.log('error', error);
            UIService.addToast('Ocorreu um erro ao carregar os dados do processo');
        }
        finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        generatePefData();
        if (loading) {
            fetchData();
        }
    }, [loading]);
    const timelineEstados = useMemo(() => estados.map(e => ({ id: e.id, label: e.designacao })), [estados]);
    const timelineHistorico = useMemo(() => (data?.Historico ?? []).map(h => ({
        id: h.id,
        estado: h.EstadoFinal.designacao,
        user: h.Funcionario.name,
        data: h.dataAlteracao,
        observacoes: h.observacoes
    })), [data?.Historico] // or [data] if Historico ref is not stable
    );
    const handleEstadoChange = useCallback(async (id, observacoes) => {
        try {
            await OblProcessoService.alteraEstado($state.params.id, data.estadoId, id, observacoes);
        }
        catch (e) {
            UIService.addToast('Ocorreu um erro ao alterar o estado do processo');
        }
        fetchData();
    }, [$state.params.id, data?.estadoId]);
    return (<Box>
      <Box sx={{ mt: 2, mb: 2 }}>
        <Breadcrumbs aria-label='breadcrumb'>
          <Link underline='none' color='inherit'>
            Obler
          </Link>
          <Link underline='hover' color='text.primary' href={$state.href('app.obler.processos.list')}>
            Processos
          </Link>
          <Link underline='hover' color='text.primary' aria-current='page'>
            {$state.params.id}
          </Link>
        </Breadcrumbs>
      </Box>
      <Grid container spacing={2}>
        <Grid sm={6} xs={12}>
          <DynamicCard sx={{ height: '100%', display: 'flex', flexDirection: 'column' }} title='Detalhes' loading={loading} actions={[
            {
                icon: mdiPencil,
                label: 'Editar',
                callback: () => {
                    showModal(DialogDetalhes, {
                        maxWidth: 'lg',
                        fullWidth: true,
                        valencias: valencias,
                        initial: {
                            valenciaId: data?.valenciaId,
                            parceiro: data?.parceiro,
                            observacoes: data?.observacoes
                        },
                        onClose: async (_) => {
                            if (_) {
                                try {
                                    await OblProcessoService.patchProcesso($state.params.id, {
                                        valenciaId: _.valenciaId,
                                        parceiro: _.parceiro,
                                        observacoes: _.observacoes
                                    });
                                    UIService.addToast('Detalhes do processo editados com sucesso');
                                }
                                catch (e) {
                                    UIService.addToast('Ocorreu um erro ao editar detalhes do processo');
                                }
                                fetchData();
                            }
                        }
                    });
                }
            }
        ]} content={[
            {
                label: 'Número Processo',
                value: loading ? <Skeleton width={140}/> : <Link onClick={() => { }}>{data?.numeroProcesso}</Link>
            },
            {
                label: 'Parceiro',
                value: data?.Cliente?.nome
            },
            {
                label: 'Número Parceiro',
                value: data?.parceiro ?? ''
            },
            {
                label: 'Valência',
                value: data?.Valencia ? `${data?.Valencia?.categoria?.designacao} - ${data?.Valencia?.designacao}` : ''
            },
            {
                label: 'Lote',
                value: data?.loteId ? `Lote ${data?.Lote.lote}` : ''
            },
            {
                label: 'Observações',
                value: data?.observacoes
            },
            {
                label: 'Estado',
                value: loading ? <Skeleton width={200}/> : <HistoryTimeline atual={data?.estadoId} estados={timelineEstados} historico={timelineHistorico} onEstadoChange={handleEstadoChange}/>
            }
        ]}/>
        </Grid>
        <Grid sm={6} xs={12}>
          <DynamicCard sx={{ height: '100%', display: 'flex', flexDirection: 'column' }} title='Faturação' loading={loading} variant='component' component={<Grid container spacing={2}>
                <Grid xs={12} sm={6}>
                  {[
                {
                    label: 'Processo',
                    align: 'right',
                    value: getValorProcesso()
                },
                {
                    label: 'Artigos',
                    align: 'right',
                    value: artigos.reduce((acc, row) => acc + row.quantidadeFaturada * row.pvp, 0).toLocaleString('pt-PT', { style: 'currency', currency: 'eur', maximumFractionDigits: 2 })
                },
                {
                    label: 'Custos',
                    align: 'right',
                    value: custos
                        .reduce((acc, row) => {
                        if (row.temValor) {
                            return acc + row.quantidade * row.valor;
                        }
                        return acc;
                    }, 0)
                        .toLocaleString('pt-PT', { style: 'currency', currency: 'eur', maximumFractionDigits: 2 })
                },
                {
                    label: 'Total',
                    align: 'right',
                    value: total.toLocaleString('pt-PT', { style: 'currency', currency: 'eur', maximumFractionDigits: 2 })
                },
                {
                    label: '',
                    value: <hr />
                },
                {
                    label: 'Por faturar',
                    align: 'right',
                    value: (total - pendente - faturado).toLocaleString('pt-PT', { style: 'currency', currency: 'eur', maximumFractionDigits: 2 })
                },
                {
                    label: 'Pendente',
                    align: 'right',
                    value: pendente.toLocaleString('pt-PT', { style: 'currency', currency: 'eur', maximumFractionDigits: 2 })
                },
                {
                    label: 'Faturado',
                    align: 'right',
                    value: faturado.toLocaleString('pt-PT', { style: 'currency', currency: 'eur', maximumFractionDigits: 2 })
                }
            ].map((row, i) => {
                return (<Grid container key={`fat-${i}-${row.label || 'sep'}`}>
                        <Grid xs={12} sm={4}>
                          <Typography variant='body2' sx={{ fontWeight: 'bold' }}>
                            {loading ? <Skeleton width={random(30, 170)}/> : row.label}
                          </Typography>
                        </Grid>
                        <Grid sm></Grid>
                        <Grid xs={12} sm={6}>
                          {React.isValidElement(row.value) ? row.value : <Typography variant='body2'>{loading ? <Skeleton width={random(10, 240)}/> : row.value}</Typography>}
                        </Grid>
                      </Grid>);
            })}
                </Grid>
                <Grid xs={12} sm={6}>
                  <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                    <FaturacaoChart pendente={pendente} faturado={faturado} total={total}/>
                  </Box>
                </Grid>
              </Grid>}/>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid xs={12} sm={6}>
          <DynamicCard actions={[
            {
                label: 'Editar',
                icon: mdiPencil,
                callback: () => {
                    showModal(DialogEditCliente, {
                        fullWidth: true,
                        maxWidth: 'lg',
                        initial: {
                            nome: data?.nomeCliente,
                            nif: data?.nifCliente,
                            contacto: data?.tlmCliente,
                            email: data?.emailCliente,
                            morada: data?.morada,
                            cep: data?.cep,
                            localidade: data?.localidade,
                            concelho: data?.concelho,
                            distrito: data?.distrito
                        },
                        lotes: lotes,
                        isFatura: false,
                        onClose: async (data) => {
                            if (data) {
                                await OblProcessoService.patchProcesso($state.params.id, {
                                    nomeCliente: data.nome,
                                    nifCliente: data.nif,
                                    tlmCliente: data.contacto,
                                    emailCliente: data.email,
                                    morada: data.morada,
                                    cep: data.cep,
                                    localidade: data.localidade,
                                    concelho: data.concelho,
                                    distrito: data.distrito,
                                    loteId: data.loteId
                                });
                                fetchData();
                                UIService.addToast('Dados de cliente editados com sucesso');
                            }
                        }
                    });
                }
            }
        ]} loading={loading} content={[
            {
                label: 'Nome',
                value: data?.nomeCliente
            },
            {
                label: 'NIF',
                value: data?.nifCliente
            },
            {
                label: 'Contacto',
                value: data?.tlmCliente ?? 'N/D'
            },
            {
                label: 'Email',
                value: data?.emailCliente ?? 'N/D'
            },
            {
                label: 'Morada',
                value: data?.morada ?? 'N/D'
            },
            {
                label: 'Código Postal',
                value: data?.cep ?? 'N/D'
            },
            {
                label: 'Localidade',
                value: data?.localidade ?? 'N/D'
            },
            {
                label: 'Concelho',
                value: data?.concelho ?? 'N/D'
            },
            {
                label: 'Distrito',
                value: data?.distrito ?? 'N/D'
            }
        ]} title={'Dados do cliente'}/>
        </Grid>
        <Grid xs={12} sm={6}>
          <DynamicCard loading={loading} actions={[
            {
                label: 'Editar',
                icon: mdiPencil,
                callback: () => {
                    showModal(DialogEditCliente, {
                        fullWidth: true,
                        maxWidth: 'lg',
                        isFatura: true,
                        lotes: lotes,
                        initial: {
                            nome: data?.faturaNome,
                            nif: data?.faturaNif,
                            contacto: data?.faturaContacto,
                            email: data?.faturaEmail,
                            morada: data?.faturaMorada,
                            cep: data?.faturaCep,
                            localidade: data?.faturaLocalidade,
                            concelho: data?.faturaConcelho,
                            distrito: data?.faturaDistrito
                        },
                        onClose: async (data) => {
                            if (data) {
                                await OblProcessoService.patchProcesso($state.params.id, {
                                    faturaNome: data.nome,
                                    faturaNif: data.nif,
                                    faturaContacto: data.contacto,
                                    faturaEmail: data.email,
                                    faturaMorada: data.morada,
                                    faturaCep: data.cep,
                                    faturaLocalidade: data.localidade,
                                    faturaConcelho: data.concelho,
                                    faturaDistrito: data.distrito
                                });
                                fetchData();
                                UIService.addToast('Dados de faturação editados com sucesso');
                            }
                        }
                    });
                }
            },
            {
                label: 'Copiar dados de cliente',
                icon: mdiClipboard,
                callback: () => {
                    OblProcessoService.patchProcesso($state.params.id, {
                        faturaNome: data?.nomeCliente,
                        faturaNif: data?.nifCliente,
                        faturaContacto: data?.tlmCliente,
                        faturaEmail: data?.emailCliente,
                        faturaMorada: data?.morada,
                        faturaCep: data?.cep,
                        faturaLocalidade: data?.localidade,
                        faturaConcelho: data?.concelho,
                        faturaDistrito: data?.distrito
                    });
                    fetchData();
                    UIService.addToast('Dados de faturação copiados de cliente');
                }
            }
        ]} content={[
            {
                label: 'Nome',
                value: data?.faturaNome
            },
            {
                label: 'NIF',
                value: data?.faturaNif
            },
            {
                label: 'Contacto',
                value: data?.faturaContacto ?? 'N/D'
            },
            {
                label: 'Email',
                value: data?.faturaEmail ?? 'N/D'
            },
            {
                label: 'Morada',
                value: data?.faturaMorada ?? 'N/D'
            },
            {
                label: 'Código Postal',
                value: data?.faturaCep ?? 'N/D'
            },
            {
                label: 'Localidade',
                value: data?.faturaLocalidade ?? 'N/D'
            },
            {
                label: 'Concelho',
                value: data?.faturaConcelho ?? 'N/D'
            },
            {
                label: 'Distrito',
                value: data?.faturaDistrito ?? 'N/D'
            }
        ]} title={'Dados de faturação'}/>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid xs={12}>
          <MaterialReactTable table={tableInteracoes}/>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid xs={12}>
          <MaterialReactTable table={tableMateriais}/>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid xs={12}>
          <MaterialReactTable table={tableEncomendas}/>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid xs={12}>
          <MaterialReactTable table={tableCustos}/>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid xs={12}>
          <MaterialReactTable table={tableAnexos}/>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid xs={12}>
          <MaterialReactTable table={tablePef}/>
        </Grid>
      </Grid>
    </Box>);
};
export default OblerProcessosDetailsView;
